/* Modulo: Social Post — play-in-place + the endless carousel.

   The loop here is NOT the coverflow's. That deck is transform-positioned, so a card
   can just take its shortest signed distance around a ring — no clones. This is a
   native scroll rail, so it needs the `tsg` machinery: cloned sets either side and a
   scrollLeft teleport, with snap suspended across the jump and the RTL scroll model
   PROBED rather than sniffed.

   Deliberately does NOT use window.moduloLazyInit — that helper lives in the theme
   *extension* core, which injected page-builder sections never load. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(RM && RM.matches); }

  function initSection(root) {
    if (!root || root.dataset.spoReady === '1') return;
    root.dataset.spoReady = '1';

    /* ─── play in place ─── */
    var plays = root.querySelectorAll('[data-spo-play]');
    for (var i = 0; i < plays.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var media = btn.closest('.modulo-spo__media');
          if (!media) return;

          /* one clip at a time — a wall of posts all talking at once is unusable */
          var others = root.querySelectorAll('.modulo-spo__media.is-playing');
          for (var k = 0; k < others.length; k++) {
            if (others[k] === media) continue;
            var ov = others[k].querySelector('[data-spo-video]');
            if (ov) { try { ov.pause(); } catch (e) {} }
            var oe = others[k].querySelector('.modulo-spo__embed');
            if (oe) oe.parentNode.removeChild(oe);
            others[k].classList.remove('is-playing');
          }

          var vid = media.querySelector('[data-spo-video]');
          if (vid) {
            media.classList.add('is-playing');
            /* the click IS the gesture, so sound is allowed — a post plays with
               sound the way it does on the platform it came from */
            vid.muted = false;
            var p = vid.play();
            if (p && p.catch) p.catch(function () { media.classList.remove('is-playing'); });
            return;
          }

          var embed = media.getAttribute('data-spo-embed');
          if (embed && !media.querySelector('.modulo-spo__embed')) {
            var f = document.createElement('iframe');
            f.className = 'modulo-spo__embed';
            f.src = embed;
            f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
            f.setAttribute('allowfullscreen', '');
            f.setAttribute('title', btn.getAttribute('aria-label') || 'Video');
            media.appendChild(f);
            media.classList.add('is-playing');
          }
        });
      })(plays[i]);
    }

    /* ─── endless carousel ─── */
    var rail = root.querySelector('[data-spo-rail]');
    if (!rail) return;
    var wantLoop = root.dataset.spoLoop === '1';
    var REAL = '.modulo-spo__cell:not([data-spo-clone])';
    var setW = 0, looping = false, raf = 0;

    /* RTL scroll models differ: a spec-compliant engine runs 0 -> negative, others
       0 -> positive. PROBE it — a wrong guess makes the "near the start edge" test
       true at rest and fires the teleport on every single frame. */
    var rtlNeg = false;
    function probe() {
      rtlNeg = false;
      if (getComputedStyle(root).direction !== 'rtl') return;
      var save = rail.scrollLeft;
      rail.scrollLeft = -1;
      rtlNeg = rail.scrollLeft < 0;
      rail.scrollLeft = save;
    }
    function maxScroll() { return rail.scrollWidth - rail.clientWidth; }
    function viewLeft() { return rtlNeg ? maxScroll() + rail.scrollLeft : rail.scrollLeft; }
    function rawFor(vl) { return rtlNeg ? vl - maxScroll() : vl; }

    function jump(vl) {
      /* snapping has to be suspended across the teleport, or the browser animates
         back toward the snap point it was mid-flight to */
      var sb = rail.style.scrollBehavior, ss = rail.style.scrollSnapType;
      rail.style.scrollBehavior = 'auto';
      rail.style.scrollSnapType = 'none';
      rail.scrollLeft = rawFor(vl);
      void rail.offsetWidth;
      rail.style.scrollSnapType = ss;
      rail.style.scrollBehavior = sb;
    }

    function clearClones() {
      var old = rail.querySelectorAll('[data-spo-clone]');
      for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    }

    function makeClone(el) {
      var c = el.cloneNode(true);
      c.setAttribute('data-spo-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('id');
      /* a duplicated editor id makes the theme editor select the wrong post */
      c.removeAttribute('data-shopify-editor-block');
      var f = c.querySelectorAll('a,button,input,select,textarea,iframe,video,[tabindex]');
      for (var i = 0; i < f.length; i++) f[i].setAttribute('tabindex', '-1');
      return c;
    }

    function build() {
      clearClones();
      looping = false;
      if (!wantLoop) return;
      if (getComputedStyle(rail).overflowX !== 'auto' && getComputedStyle(rail).overflowX !== 'scroll') return;

      var reals = rail.querySelectorAll(REAL);
      if (reals.length < 3) return;

      var first = reals[0], last = reals[reals.length - 1];
      setW = (last.offsetLeft + last.offsetWidth) - first.offsetLeft;

      /* If the real set already fits there is nothing to scroll, and cloning would
         conjure a rail out of nothing — 3 posts at 3-up would become 9. */
      if (setW <= rail.clientWidth + 1) return;

      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      for (var i = 0; i < reals.length; i++) {
        before.appendChild(makeClone(reals[i]));
        after.appendChild(makeClone(reals[i]));
      }
      rail.insertBefore(before, rail.firstChild);
      rail.appendChild(after);

      looping = true;
      probe();
      jump(setW);   // park on the real set
    }

    function sync() {
      if (!looping) return;
      var vl = viewLeft();
      if (vl < setW * 0.5) jump(vl + setW);
      else if (vl > setW * 1.5) jump(vl - setW);
    }
    rail.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; sync(); });
    }, { passive: true });

    function step(dir) {
      var one = rail.querySelector(REAL);
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var w = one ? one.offsetWidth + gap : rail.clientWidth;
      var target = rawFor(viewLeft() + dir * w);
      if (reduced() || !rail.scrollTo) rail.scrollLeft = target;
      else rail.scrollTo({ left: target, behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-spo-prev]');
    var next = root.querySelector('[data-spo-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    /* A responsive column count changes the set width, so the clone train has to be
       rebuilt — topping it up is not enough. */
    var rz;
    function onResize() { clearTimeout(rz); rz = setTimeout(build, 140); }
    window.addEventListener('resize', onResize);
    root._spoResize = onResize;

    build();
  }

  function bootstrap(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-spo]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  /* An identical <script src> still executes once per tag, so document listeners
     have to be wired exactly once. */
  if (!window.moduloSpoWired) {
    window.moduloSpoWired = true;
    document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var els = e.target.querySelectorAll('[data-modulo-spo]');
      for (var i = 0; i < els.length; i++) {
        if (els[i]._spoResize) window.removeEventListener('resize', els[i]._spoResize);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
})();
